/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceReferenceRequest } from "./DeviceReferenceRequest";
import {
    DeviceReferenceRequestFromJSON,
    DeviceReferenceRequestFromJSONTyped,
    DeviceReferenceRequestToJSON,
} from "./DeviceReferenceRequest";

/**
 *
 * @export
 * @interface DeviceInvitationRequest
 */
export interface DeviceInvitationRequest {
    /**
     * Optional message displayed to user when they accept the invite code
     * @type {string}
     * @memberof DeviceInvitationRequest
     */
    message?: string;
    /**
     * list of devices this invite allows access to
     * @type {Array<DeviceReferenceRequest>}
     * @memberof DeviceInvitationRequest
     */
    devices?: Array<DeviceReferenceRequest>;
    /**
     * The access level this invite allows access to
     * @type {string}
     * @memberof DeviceInvitationRequest
     */
    deviceAccessLevel?: DeviceInvitationRequestDeviceAccessLevelEnum;
    /**
     * Allowed values: InstallerDeviceInvite, SimpleDeviceInvite, BillingDeviceInvite.
     * @type {string}
     * @memberof DeviceInvitationRequest
     */
    type?: DeviceInvitationRequestTypeEnum;
    /**
     * Max number of times this invite can be accepted. 1 for single use invites. If an AccessDurationSeconds is set, this must be 1
     * @type {number}
     * @memberof DeviceInvitationRequest
     */
    acceptedLimit?: number;
    /**
     * The duration this temporary invitiation grants access for. Access is removed after AcceptedAt+AccessDurationSeconds. Null for permanent access.
     * @type {number}
     * @memberof DeviceInvitationRequest
     */
    accessDurationSeconds?: number;
    /**
     * Invitation expiration. If not set, a default (eg 1 month) is used.
     * @type {Date}
     * @memberof DeviceInvitationRequest
     */
    expiresAt?: Date;
    /**
     * IL-3658: Recipient name. Only for BillingDeviceInvite.
     * @type {string}
     * @memberof DeviceInvitationRequest
     */
    name?: string;
    /**
     * IL-3658: Recipient mobile number in international format. Only for BillingDeviceInvite.
     * @type {string}
     * @memberof DeviceInvitationRequest
     */
    mobileNo?: string;
    /**
     * IL-3658: Recipient email address. Only for BillingDeviceInvite.
     * @type {string}
     * @memberof DeviceInvitationRequest
     */
    email?: string;
}

/**
 * @export
 */
export const DeviceInvitationRequestDeviceAccessLevelEnum = {
    Owner: "Owner",
    SecondaryUser: "SecondaryUser",
} as const;
export type DeviceInvitationRequestDeviceAccessLevelEnum =
    (typeof DeviceInvitationRequestDeviceAccessLevelEnum)[keyof typeof DeviceInvitationRequestDeviceAccessLevelEnum];

/**
 * @export
 */
export const DeviceInvitationRequestTypeEnum = {
    DeviceOwnerVerification: "DeviceOwnerVerification",
    InstallerDeviceInvite: "InstallerDeviceInvite",
    SimpleDeviceInvite: "SimpleDeviceInvite",
    BillingDeviceInvite: "BillingDeviceInvite",
} as const;
export type DeviceInvitationRequestTypeEnum =
    (typeof DeviceInvitationRequestTypeEnum)[keyof typeof DeviceInvitationRequestTypeEnum];

/**
 * Check if a given object implements the DeviceInvitationRequest interface.
 */
export function instanceOfDeviceInvitationRequest(
    value: object,
): value is DeviceInvitationRequest {
    return true;
}

export function DeviceInvitationRequestFromJSON(
    json: any,
): DeviceInvitationRequest {
    return DeviceInvitationRequestFromJSONTyped(json, false);
}

export function DeviceInvitationRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceInvitationRequest {
    if (json == null) {
        return json;
    }
    return {
        message: json["message"] == null ? undefined : json["message"],
        devices:
            json["devices"] == null
                ? undefined
                : (json["devices"] as Array<any>).map(
                      DeviceReferenceRequestFromJSON,
                  ),
        deviceAccessLevel:
            json["deviceAccessLevel"] == null
                ? undefined
                : json["deviceAccessLevel"],
        type: json["type"] == null ? undefined : json["type"],
        acceptedLimit:
            json["acceptedLimit"] == null ? undefined : json["acceptedLimit"],
        accessDurationSeconds:
            json["accessDurationSeconds"] == null
                ? undefined
                : json["accessDurationSeconds"],
        expiresAt:
            json["expiresAt"] == null ? undefined : new Date(json["expiresAt"]),
        name: json["name"] == null ? undefined : json["name"],
        mobileNo: json["mobileNo"] == null ? undefined : json["mobileNo"],
        email: json["email"] == null ? undefined : json["email"],
    };
}

export function DeviceInvitationRequestToJSON(
    value?: DeviceInvitationRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        message: value["message"],
        devices:
            value["devices"] == null
                ? undefined
                : (value["devices"] as Array<any>).map(
                      DeviceReferenceRequestToJSON,
                  ),
        deviceAccessLevel: value["deviceAccessLevel"],
        type: value["type"],
        acceptedLimit: value["acceptedLimit"],
        accessDurationSeconds: value["accessDurationSeconds"],
        expiresAt:
            value["expiresAt"] == null
                ? undefined
                : value["expiresAt"].toISOString(),
        name: value["name"],
        mobileNo: value["mobileNo"],
        email: value["email"],
    };
}
